export const LEGAL_OPERATOR = {
  brandName: 'AI-Tenders',
  fullName: 'ИП КОВЗАЛОВ АЛЕКСЕЙ АЛЕКСАНДРОВИЧ',
  inn: '781143211731',
  ogrnip: '325784700148150',
  ogrnipIssuedAt: '7 мая 2025 г.',
  registeredAt: '7 мая 2025 г.',
  location: 'г. Санкт-Петербург',
  email: 'Ai@neyrosvet.ru',
  phone: '+7 (953) 341-65-48',
  phoneHref: 'tel:+79533416548',
  emailHref: 'mailto:Ai@neyrosvet.ru',
  siteUrl: 'https://ai-tenders.ru',
}

export const operatorRequisitesLine = `${LEGAL_OPERATOR.fullName}, ИНН ${LEGAL_OPERATOR.inn}, ОГРНИП ${LEGAL_OPERATOR.ogrnip}`
